import React, { useState, useEffect } from 'react'
import './TaskModel.scss'

import Screen from './partials/Screen.js'
import AudioManager from './partials/AudioManager.js'
import Gesture from './partials/Gesture.js'
import Hud from './partials/Hud.js'
import Help from './partials/Help.js'
import Popup from './partials/TaskModelPopup.js'
import Note from './partials/TaskModelNote.js'

const TaskModel = props => {


    const [stepIndex, setStepIndex] = useState(0);
    const [gestureIndex, setGestureIndex] = useState(0);
    const [furthestStep, setFurthestStep] = useState(0);
    const [introOpen, setIntroOpen] = useState(true);
    const [helpOpen, setHelpOpen] = useState(false);

    const [debugMode, setDebugMode] = useState(false);

    useEffect(() => {
        //whenever stepIndex changes, reset gestureIndex to 0
        if (gestureIndex !== 0) {
            setGestureIndex(0)
        }
        if(furthestStep < stepIndex){
            setFurthestStep(stepIndex)
        }
    }, [stepIndex])


    const currentStepData = getValue(['steps', stepIndex], props.data)
    const nextStepData = getValue(['steps', stepIndex + 1], props.data)
    const currentGestureData = getValue(['gestures', gestureIndex], currentStepData)
    const nextGestureData = getValue(['gestures', gestureIndex + 1], currentStepData) || getValue(['gestures', gestureIndex + 1], nextStepData)

    const onGestureComplete = () => {
        console.log('gestureComplete', gestureIndex, (getValue(['gestures', 'length'], currentStepData) || 0) - 1 > gestureIndex)
        if((getValue(['gestures', 'length'], currentStepData) || 0) - 1 > gestureIndex){
            setGestureIndex(gestureIndex + 1);
        }else{
            //end of step
            onStepComplete()
        }
    }

    const onStepComplete = () => {
        console.log('stepComplete', stepIndex, (getValue(['steps', 'length'], props.data) || 0) - 1 > stepIndex)

        if((getValue(['steps', 'length'], props.data) || 0) - 1 > stepIndex){
            setStepIndex(stepIndex + 1);
        }else{
            onTaskComplete()
        }
    }

    const onTaskComplete = () => {
        props.onComplete();
    }

    const onMenuStepClick = (idx) => {
        if(idx <= furthestStep){
            setStepIndex(idx)
        }
    }

   
    return (
        <div className={`TaskModel ${debugMode ? 'debug' : ''}`}>
            {/* <pre>
                {JSON.stringify(currentGestureData, null, 2)}
            </pre> */}

            {/* screen image*/}
            <Screen
                source={getValue(['screen', 'path'], currentGestureData)}
                alt={getValue(['screen', 'alt'], currentGestureData)}
                nextSource={getValue(['screen', 'path'], nextGestureData)}
            />

            {/* gesture layer (actual interaction) */}
            {currentGestureData && <Gesture
                data={currentGestureData}
                onGestureComplete={onGestureComplete}
            />}

            {/* Note (stepText) */}
            {currentGestureData && <Note
                stepIndex={stepIndex}
                data={getValue(['note'], currentGestureData)}
            />}

            {/* audio manager */}
            <AudioManager
                currentGestureData={currentGestureData}
                introOpen={introOpen}
                gestureIndex={gestureIndex}
                stepIndex={stepIndex}
            />

            {/* hud/menu */}
            <Hud
                steps={getValue(['steps'], props.data)}
                stepIndex={stepIndex}
                hintHTML={getValue(['hint'], currentStepData)}
                onMenuStepClick={onMenuStepClick}
                setIntroOpen={setIntroOpen}
                setHelpOpen={setHelpOpen}
            />


            {/* popups */}
            {/* intro/scenarioText popup */}
            {
                introOpen && <Popup
                    scrim={true}
                    heading={props.data.taskTitle}
                    text={props.data.scenarioText}
                    button={'Continue'}
                    onButtonClick={()=>setIntroOpen(false)}
                />
            }
            {/* Help popup */}
            {
                helpOpen && <Help
                    setHelpOpen={setHelpOpen}
                />
            }

        </div>
    )
}


const getValue = (propertyPath, obj) => {
    //safe getter for object tree navigation 

    // https://medium.com/data-scraper-tips-tricks/safely-read-write-in-deeply-nested-objects-js-a1d9ddd168c6

    // this is a super simple parsing, you will want to make this more complex to handle correctly any path
    // it will split by the dots at first and then simply pass along the array (on next iterations)
    let properties = Array.isArray(propertyPath) ? propertyPath : propertyPath.split(".")

    // Not yet at the last property so keep digging
    if(obj === undefined) return undefined;
    if (properties.length > 1) {
        if (typeof obj !== 'object') return undefined;
        // The property doesn't exists OR is not an object (and so we overwritte it) so we create it
        if (!obj.hasOwnProperty(properties[0]) || typeof obj[properties[0]] !== "object") obj[properties[0]] = {}
        // We iterate.
        return getValue(properties.slice(1), obj[properties[0]])
        // This is the last property - the one where to set the value
    } else if (properties.length === 1) {
        return obj[properties[0]] // this is the end
    } else if (properties.length === 0) {
        return obj;
    }

}

export default TaskModel